const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email) {
    return EMAIL_PATTERN.test((email || '').trim());
}

export function normalizeEmail(email) {
    return (email || '').trim().toLowerCase();
}
